<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkdatefield  label="日期" #KA001Com  id="KA001"  [(value)]="item.KA001" [required]="true"  placeholder="日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktext  label="時間" [value]="item.KA002"     >
    </app-jktext>
    <app-jkedit  label="公司代號" #KA003Com  id="KA003"  [(value)]="item.KA003" [required]="true"  placeholder="公司代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="程式代號" #KA004Com  id="KA004"  [(value)]="item.KA004" [required]="true"  placeholder="程式代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="處理進度" #KA006Com  id="KA006"  [(value)]="item.KA006" placeholder="處理進度"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="工作電腦" #KA007Com  id="KA007"  [(value)]="item.KA007" placeholder="工作電腦"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="分類" #KA008Com  id="KA008"  [(value)]="item.KA008" placeholder="分類"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="開始時間" #KA009Com  id="KA009"  [(date)]="item.KA009" placeholder="開始時間"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkdatefield  label="完成時間" #KA010Com  id="KA010"  [(date)]="item.KA010" placeholder="完成時間"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktextarea  height="250px" 
 label="處理結果" #KA011Com  id="KA011"  [(value)]="item.KA011" placeholder="處理結果"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jknumberedit  label="錯誤個數" #KA012Com  id="KA012"  [(value)]="item.KA012" placeholder="錯誤個數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="警告個數" #KA013Com  id="KA013"  [(value)]="item.KA013" placeholder="警告個數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="參數內容" #KA014Com  id="KA014"  [(value)]="item.KA014" placeholder="參數內容"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="使用者代號" #KA015Com  id="KA015"  [(value)]="item.KA015" placeholder="使用者代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="定時工作代號" #KA016Com  id="KA016"  [(value)]="item.KA016" placeholder="定時工作代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="成功筆數" #KA017Com  id="KA017"  [(value)]="item.KA017" placeholder="成功筆數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="失敗筆數" #KA018Com  id="KA018"  [(value)]="item.KA018" placeholder="失敗筆數"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="MAIL通知方式" #KA019Com  id="KA019"  [(value)]="item.KA019" placeholder="MAIL通知方式"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="MAIL帳號" #KA020Com  id="KA020"  [(value)]="item.KA020" placeholder="MAIL帳號"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>